<template>
  <div class="subscription" style="height: 100%; font-size: 0">
    <iframe
      ref="myIframe"
      :src="iframeUrl"
      frameborder="0"
      scrolling="auto"
      allowfullscreen="true"
      allowtransparency="true"
      width="100%"
      style="height: calc(100vh - 72px)"
      allow="autoplay"
    >
    </iframe>
  </div>
</template>
<script>
import { Login, Registe } from "@/assets/js/login.js";
import Footer from "@/components/Footer_q.vue";
import { mapState } from "vuex";
export default {
  name: "subscription",
  data() {
    return {
      iframeUrl: "",
    };
  },
  components: {
    MFooter: Footer,
  },
  computed: {
    ...mapState({
      proToken: (state) => state.indexStore.B_PRO_TOKEN,
    }),
  },
  created() {
    this.setIframeUrl();
  },
  mounted() {
    window.addEventListener('message',e=>{
			if(e.data.msg==='subsciptcenter'){
        // 判断是否登录
        let url = this.getOldPageUrl();
        if (url) {
          Login(url);
        } else {
          Login();
        } 
			} 
		}); 
  },
  methods: {
    setIframeUrl() {
      let url = process.env.VUE_APP_SUBSCRIPTION_URL;
      let params =
        process.env.VUE_APP_IFRAME_PARAMS +
        "&PAGE_URL=" +
        window.location.host +
        "&sessionToken=" +
        this.proToken;
      this.iframeUrl = url + "?" + params;
    },
    getOldPageUrl() {
      let oldPageUrl = "";
      oldPageUrl = `${window.location.origin}/VSubscriptionCenter`;
      return oldPageUrl;
    },
  },
};
</script>
<style scoped>
</style> 